import { useCallback, useEffect } from "react";
import { InfoMessageType } from "src/Components/InfoBar/InfoBar";
import StorageInfo from "./StorageInfo";
import { ClinicStorageError, useGetStorageLicenceInfo } from "src/Utils/Hooks/ManageLicenses/useGetStorageLicenceInfo";
import { ILicensesInfo } from "src/Utils/Hooks/ManageLicenses/useGetLicensesInfo";

interface IStorageLicensesParams {
    clinicId:string;
    setInfo: (message: string, type: InfoMessageType) => void;
    updatePageLoader: (load: boolean) => void;
    licensesInfo: ILicensesInfo;
    isSuiteLicense: boolean;
    showPaymentOption: boolean;
    containsSuiteLicense: boolean;
}

const CloudStorage: React.FC<IStorageLicensesParams> = ({ clinicId, setInfo, updatePageLoader, licensesInfo, isSuiteLicense, showPaymentOption, containsSuiteLicense }) => {
    const { storageInfo, loading, getStorageInfo } = useGetStorageLicenceInfo()
    useEffect(() => {
        updatePageLoader(loading)
    }, [loading, updatePageLoader])

    const setStorageInfoMessage = useCallback((message: string, messageType: InfoMessageType) => {
        if (messageType === InfoMessageType.success) {
            getStorageInfo();
        }
        if (messageType === InfoMessageType.error) {
            setInfo(message, messageType);
        }
    },[setInfo, getStorageInfo])
    useEffect(() => {
        if (licensesInfo.clinicUserAndStorageLicenseInfo) {
            getStorageInfo()
        }
    }, [licensesInfo.clinicUserAndStorageLicenseInfo, getStorageInfo])

    return (
        <>
            {storageInfo && 
                (
                    storageInfo.storageError !== ClinicStorageError.NO_LICENSE &&
                        <div className="mb-3">
                            <StorageInfo
                                clinicId={clinicId}
                                storageInfo={storageInfo}
                                setInfo={setStorageInfoMessage}
                                updatePageLoader={updatePageLoader}
                                licensesInfo={licensesInfo}
                                isSuiteLicense={isSuiteLicense}
                                showPaymentOption={showPaymentOption}
                                containsSuiteLicense={containsSuiteLicense}
                            />
                        </div>
                )
            }
        </>
    )
}
export default CloudStorage;

